<template>
  <div ref="domRef" class="base-card-info">
    <div class="info-card-title">
      营业执照信息
    </div>
    <div class="base-info-list">
      <div class="left-list gap-y-[14px]">
        <div class="item">
          <div class="label">
            企业名称
          </div>
          <div class="value">
            {{ baseInfo.serverBusiness?.name }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            企业简称
          </div>
          <div class="value">
            {{ baseInfo.serverBusiness?.shortName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            统一社会信用代码
          </div>
          <div class="value">
            {{ baseInfo.serverBusiness?.creditCode }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            法定代表人姓名
          </div>
          <div class="value">
            {{ baseInfo.serverBusiness?.legalName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            注册地址
          </div>
          <div class="value">
            {{ baseInfo.serverBusiness?.address }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            营业执照有效期
          </div>
          <div class="value">
            <span>{{ baseInfo.serverBusiness?.businessLicenseStartDate }}</span>
            <span> ~ </span>
            <span>{{ baseInfo.serverBusiness?.businessLicenseEndDate }}&nbsp;&nbsp;</span>
            <span v-if="['29991231', '2999-12-31'].includes(baseInfo.serverBusiness?.businessLicenseEndDate)">长期</span>
          </div>
        </div>
        <div class="item">
          <div class="label">
            经营范围
          </div>
          <div class="value">
            {{ baseInfo.serverBusiness?.businessScope }}
          </div>
        </div>
      </div>
      <div class="right-list">
        <div class="item">
          <div class="label">
            营业执照照片
          </div>
          <div class="value">
            <div class="business-license-box">
              <img
                :src="baseInfo.serverBusiness?.businessLicensePic"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IServerMergeInfo } from '@core/main/types';
import { useElementImgPreview } from '@vue3/components';
import { inject, ref } from 'vue';

defineOptions({ name: 'BusinessLicenseInfo' }); // 账户中心 - 营业执照信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

const baseInfo = inject('baseInfo') as IServerMergeInfo;

</script>
